import React from 'react';
import { Sparkles } from 'lucide-react';

interface SkillCardProps {
  name: string;
  description: string;
  badge?: React.ReactNode;
  primaryAction?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  onClick?: () => void;
}

export const SkillCard = ({
  name,
  description,
  badge,
  primaryAction,
  secondaryAction,
  onClick,
}: SkillCardProps) => {
  const isClickable = !!onClick;
  const hasActions = !!(primaryAction || secondaryAction);

  const headerContent = (
    <div className="flex items-start gap-3 w-full">
      <div className="flex-shrink-0 w-9 h-9 rounded-md bg-[#F3F5F9] flex items-center justify-center text-brand-dark">
        <Sparkles className="h-4 w-4" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold text-[#252F33] truncate">
            {name}
          </h3>
          {badge}
        </div>
        <p className="text-xs text-[#768D95] mt-1 line-clamp-2 text-left">
          {description}
        </p>
      </div>
    </div>
  );

  return (
    <div
      className={`bg-white border border-slate-200 rounded-lg transition-all ${
        isClickable ? 'hover:border-brand-link hover:shadow-sm' : ''
      }`}>
      {isClickable ? (
        <button
          type="button"
          onClick={onClick}
          className="w-full text-left p-4 rounded-lg cursor-pointer">
          {headerContent}
        </button>
      ) : (
        <div className="p-4">{headerContent}</div>
      )}
      {hasActions && (
        <div className="flex items-center justify-end gap-2 px-4 pb-4 -mt-1">
          {secondaryAction}
          {primaryAction}
        </div>
      )}
    </div>
  );
};
